fx.ns("shared.renderers", class FrontCoverRenderer extends fx.Component {
    
	constructor(data, book)
	{
        super(data);
        this.book = book;
    }

    create()
    {
        let thumb, width, height;
        switch(this.book.shape_option)
        {
            case "square":
                thumb = this.data.thumb_front_square;
                width = 210;
                height = 210;
                break;
            case "landscape":
                thumb = this.data.thumb_front_landscape;
                width = 210;
                height = 147;
                break;
            case "portrait":
                thumb = this.data.thumb_front_portrait;
                width = 168;
                height = 240;
                break;
        }

        this.thumbnail = new fx.components.Image({className : "cover-thumb", data : thumb});
		this.usedIcon = new fx.components.Image({data : fx.assets.used2, className : "usedIcon"});
		this.usedIcon.visibleAtStart = false;
		
        // The thumbnail takes the renderer width (the grid may make it narrower than width once a scrollbar is
        // deducted, a fixed pixel size would get cropped) and its height is computed from the cover ratio, so the
        // image is really laid out at the cover proportions even when the grid cell is taller (row gap).
        this.thumbnail.css("aspect-ratio", width + " / " + height);
		this.addChild( this.thumbnail, { width : "100%", height : "auto"});
        this.addChild(this.usedIcon, {top:5, right:5, width:32, height:32});

        this.attr("data-behaviour", "apply-layout");
        this.attr("data-class", "Theme");
        this.attr("data-id", this.data.id);
        this.addClass("draggable");
    }

    onDataUpdated(action)
    {
        if (action.impacts("selected") || action.type == "init")
        {
            if (this.data.selected)
                this.usedIcon.show();
            else
                this.usedIcon.hide();
        }
    }
});
